import TagView from './TagView'

class Bridge {

	constructor(bridgeE, options) {
		options = Object.assign({
			slugs: null,
			excludes: null
		}, options)

		const tagIds = (value => {
			if (!/^(-?[1-9][0-9]*(,-?[1-9][0-9]*)*)?$/.test(value)) return []
			return value.split(/,/).map(id => parseInt(id, 10))
		})(bridgeE.value)

		this.bridgeE = bridgeE
		bridgeE.setAttribute('type', 'hidden')

		this.container = this.createContainer()
		this.app = new Vue({
			el: this.container,
			data() {
				return {
					tagIds,
					options
				}
			},
			components: {
				TagView
			},
			template: `<TagView v-model="tagIds" v-bind="options" />`,
			watch: {
				tagIds() {
					bridgeE.value = this.tagIds.join(',')
				}
			}
		})
	}

	createContainer() {
		const container = document.createElement('div')
		const { bridgeE } = this
		bridgeE.parentNode.insertBefore(container, bridgeE)
		return container
	}
}

export default Bridge
